import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Header from '../components/Header';

// Pages
import Home from '../pages/Home';
import About from '../pages/About';
import Activities from '../pages/Activities';
import GetInvolved from '../pages/GetInvolved';
import Login from '../pages/Login';
import Dashboard from '../pages/Dashboard.jsx';
import Donors from '../pages/Donors';
import Volunteers from '../pages/Volunteers';
import BlogListAdmin from '../pages/BlogListAdmin.jsx';
import VolunteerList from '../components/VolunteerList.jsx';
import BlogList from '../components/BlogList';
import BlogForm from '../components/BlogForm';

import BlogDetail from '../components/BlogDetail';

// Components
import Layout from '../components/Layout';
import NotFoundd from '../components/NotFoundd';
import LogoLoader  from '../components/LogoLoader';
import DonationDetails  from '../components/DonationDetails';
import DonationDetailsAnother  from '../components/DonationDetailsAnother';

import UnderDoo  from '../pages/UnderDoo';

import PrivacyPolicy  from '../pages/PrivacyPolicy';
import TermConditions  from '../pages/TermConditions';


// IRC Components
import IRCTV from '../components/IRCTV';
import IRCCHARITY from '../components/IRCCHARITY';
import IRCDENTAL from '../components/IRCDENTAL';
import IRCPATHO from '../components/IRCPATHO';
import IRCSTUDY from '../components/IRCSTUDY';
import IRCTECHNICAL from '../components/IRCTECHNICAL';
import IRCWOMEN from '../components/IRCWOMEN';
import IRCCOMMUNITY from '../components/IRCCOMMUNITY';
import IRCCALL from '../components/IRCCALL';
import IRCMEDICAL from '../components/IRCMEDICAL.jsx';
import IRCDASTAR from '../components/IRCDASTAR.jsx';
import IRCRATION from '../components/IRCRATION.jsx';
import IRCWATER from '../components/IRCWATER.jsx';
import IRCSKILL from '../components/IRCSKILL.jsx';
import IRCWE from '../components/IRCWE.jsx';
import IRCPRODUCTION from '../components/IRCPRODUCTION.jsx';
import IRCREFERENCE from '../components/IRCREFERENCE.jsx';
import IRCPATH from '../components/IRCPATH.jsx';
import IRCarabic from '../components/IRCarabic.jsx';
import IRCconference from '../components/IRCconference.jsx';
import IRCLADIES from '../components/IRCLADIES.jsx';
import IRCCHILDREN from '../components/IRCCHILDREN.jsx';
import IRCWEEKLY from '../components/IRCWEEKLY.jsx';
// import IRCDAWAH from '../components/IRCDAWAH.jsx';
import IRCSUMMER from '../components/IRCSUMMER.jsx';
import IRCEXHIBITION from '../components/IRCEXHIBITION.jsx';
import IRCMINORITY from '../components/IRCMINORITY.jsx';
import IRCALKITAB from '../components/IRCALKITAB.jsx';
import IRCILM from '../components/IRCILM.jsx';
import IRCFREEBOOKBANK from '../components/IRCFREEBOOKBANK.jsx';
import Achievements from '../components/Achievements.jsx';
import ContactForm from '../pages/ContactForm.jsx';

import StatsAdmin from '../components/StatsAdmin';

import SuccessPage from '../components/SuccessPage';
import FailurePage from '../components/FailurePage';

// Wrapper to conditionally show Header
const AppContent = ({ isAuthenticated, user, handleLogin, handleLogout }) => {
  const location = useLocation();

  // Define routes where you DON'T want the Header
  const hideHeaderPaths = [
    '/layout',
    '/admindashboard',
    '/donors',
    '/volunteers',
    '/bloglistadmin',
    '/volunteerlist'
  ];

  const shouldHideHeader = hideHeaderPaths.some(path => location.pathname.startsWith(path));

  return (
    <>
      {!shouldHideHeader && <Header />}
      <Routes>
        <Route path="/login" element={
          isAuthenticated ? <Navigate to="/layout" /> : <Login onLogin={handleLogin} />
        } />
        <Route path="/admindashboard" element={
          isAuthenticated ? (
            <Layout user={user} onLogout={handleLogout}>
              <Dashboard />
            </Layout>
          ) : <Navigate to="/login" />
        } />
        <Route path="/donors" element={
          isAuthenticated ? (
            <Layout user={user} onLogout={handleLogout}>
              <Donors />
            </Layout>
          ) : <Navigate to="/login" />
        } />
        <Route path="/volunteers" element={
          isAuthenticated ? (
            <Layout user={user} onLogout={handleLogout}>
              <Volunteers />
            </Layout>
          ) : <Navigate to="/login" />
        } />
        <Route path="/bloglistadmin" element={
          isAuthenticated ? (
            <Layout user={user} onLogout={handleLogout}>
              <BlogListAdmin />
            </Layout>
          ) : <Navigate to="/login" />
        } />
        <Route path="/volunteerlist" element={
          isAuthenticated ? (
            <Layout user={user} onLogout={handleLogout}>
              <VolunteerList />
            </Layout>
          ) : <Navigate to="/login" />
        } />

        <Route path="/stats-admin" element={
          isAuthenticated ? (
            <Layout user={user} onLogout={handleLogout}>
              <StatsAdmin />
            </Layout>
          ) : <Navigate to="/login" />
        } />

        {/* Public routes */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/activities.html" element={<Activities />} />
        <Route path="/get-involved" element={<GetInvolved />} />
        <Route path="/bloglist" element={<BlogList />} />
        <Route path="/blogform" element={<BlogForm />} />
        <Route path= '/admin/blog/edit/:id' element={<BlogForm />} />
        <Route path="/blog/:id" element={<BlogDetail />} />

        <Route path="/irc-tv" element={<IRCTV />} />
        <Route path="/irc-charity" element={<IRCCHARITY />} />
        <Route path="/irc-dental" element={<IRCDENTAL />} />
        <Route path="/irc-patho" element={<IRCPATHO />} />
        <Route path="/irc-study" element={<IRCSTUDY />} />
        <Route path="/irc-technical" element={<IRCTECHNICAL />} />
        <Route path="/irc-women" element={<IRCWOMEN />} />
        <Route path="/irc-community" element={<IRCCOMMUNITY />} />
        <Route path="/irc-call" element={<IRCCALL />} />
        <Route path="/irc-medical" element={<IRCMEDICAL />} />
        <Route path="/irc-dastar" element={<IRCDASTAR />} />
        <Route path="/irc-ration" element={<IRCRATION />} />
        <Route path="/irc-water" element={<IRCWATER />} />
        <Route path="/irc-skill" element={<IRCSKILL />} />
        <Route path="/irc-we" element={<IRCWE />} />
        <Route path="/irc-production" element={<IRCPRODUCTION />} />
        <Route path="/irc-refernce" element={<IRCREFERENCE />} />
        <Route path="/irc-path" element={<IRCPATH />} />
        <Route path="/irc-arabic" element={<IRCarabic />} />
        <Route path="/irc-conference" element={<IRCconference />} />
        <Route path="/irc-ladies" element={<IRCLADIES />} />
        <Route path="/irc-children" element={<IRCCHILDREN />} />
        <Route path="/irc-weekly" element={<IRCWEEKLY />} />
        {/* <Route path="/irc-dawah" element={<IRCDAWAH />} /> */}
        <Route path="/irc-summer" element={<IRCSUMMER />} />
        <Route path="/irc-exhibition" element={<IRCEXHIBITION />} />
        <Route path="/irc-minority" element={<IRCMINORITY />} />
        <Route path="/irc-alkitab" element={<IRCALKITAB />} />
        <Route path="/irc-ilm" element={<IRCILM />} />
        <Route path="/irc-freebookbank" element={<IRCFREEBOOKBANK />} />
        <Route path="/ir-achievements" element={<Achievements />} />
        <Route path="/contact-us" element={<ContactForm />} />

        <Route path="/payment-success" element={<SuccessPage />} />
<Route path="/payment-failed" element={<FailurePage />} />
<Route path="/payment-error" element={<div>Payment Error</div>} />

        <Route path="/layout" element={<Layout />} />
        <Route path="*" element={<NotFoundd />} />
        <Route path="/help-us.html" element={<DonationDetails />} />
        <Route path="/DonationDetailsAnother" element={<DonationDetailsAnother />} />

        <Route path="/underdevelopment" element={<UnderDoo />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms&conditions" element={<TermConditions />} />

      </Routes>
    </>
  );
};

const AppRouter = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const storedUser = localStorage.getItem('user');

    if (token && storedUser) {
      try {
        setIsAuthenticated(true);
        const userData = typeof storedUser === 'string' ? JSON.parse(storedUser) : storedUser;
        setUser(userData);
      } catch (error) {
        console.error('Error parsing user data:', error);
        localStorage.removeItem('user');
        localStorage.removeItem('token');
      }
    }

    // Delay the loading screen for exactly 5 seconds
  const timer = setTimeout(() => {
    setLoading(false);
  }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const handleLogin = (token, userData) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    setIsAuthenticated(true);
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setIsAuthenticated(false);
    setUser(null);
  };

if (loading) return <LogoLoader/>;

  return (
    <Router>
      <AppContent
        isAuthenticated={isAuthenticated}
        user={user}
        handleLogin={handleLogin}
        handleLogout={handleLogout}
      />
    </Router>
  );
};

export default AppRouter;








